import { useMemo } from 'react';
import Immutable from 'immutable';
import UICardGrid from 'UIComponents/card/UICardGrid';
import UILoadingSpinner from 'UIComponents/loading/UILoadingSpinner';
import { useResponsiveProps } from 'marketplace-ui-common/hooks/useResponsiveProps';
import { isFulfilled } from 'marketplace-ui-common/requestStates/RequestStateUtils';
import ResultCard from './ResultCard';
import { jsx as _jsx } from "react/jsx-runtime";
const ResultsGrid = ({
  className,
  onResultClick,
  requestState,
  resultProps,
  results,
  section
}) => {
  const responsiveProps = useResponsiveProps({
    columns: {
      xs: 1,
      lg: 2,
      xl: 3
    }
  });
  const renderedResults = useMemo(() => {
    const resultsArray = Immutable.Iterable.isIterable(results) ? results.toArray() : results.slice(0);
    return resultsArray.map((result, index) => {
      return /*#__PURE__*/_jsx(ResultCard, Object.assign({}, resultProps, {
        onClick: () => {
          onResultClick(result, index, resultsArray.length, section);
        },
        result: result
      }), result.id);
    });
  }, [onResultClick, resultProps, results, section]);
  if (!isFulfilled(requestState)) {
    return /*#__PURE__*/_jsx(UILoadingSpinner, {
      "data-selenium-id": "results-loading-spinner",
      grow: true,
      minHeight: 150,
      layout: "centered"
    });
  }
  return /*#__PURE__*/_jsx(UICardGrid, Object.assign({}, responsiveProps, {
    className: className,
    gutterSize: 16,
    children: renderedResults
  }));
};
export default ResultsGrid;